"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Module = void 0;
const inversify_1 = require("inversify");
/**
 * Module decorator.
 */
const Module = () => {
    return (target) => {
        inversify_1.injectable()(target);
    };
};
exports.Module = Module;
//# sourceMappingURL=decorator.js.map